var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamePoint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "210 150 420 300",
    style: {
      enableBackground: "new 0 0 841.9 595.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#002448;}\r\n\t.st1{fill:#28B8CE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.7,138.3v55.4h-79.1c0,0-28-5.6-28.5,39c-0.6,44.3,0,152.2,0,152.2H433l0.6-74.3h-20.1l-0.6-57.9h80.8 v191.2H374.2c0,0-57.3-10.4-48.9-73.1l-0.8-159.6c0,0,8.2-68.9,78.8-75.4L493.7,138.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 259.7,
    cy: 317.4,
    r: 20.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 547.8,
    cy: 317.4,
    r: 20.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.6,146.7V202h-79.1c0,0-28-5.6-28.5,39c-0.6,44.3,0,152.2,0,152.2h46.9l0.6-74.3h-20.1l-0.6-57.9h80.8 v191.2H360.1c0,0-57.3-10.4-48.9-73.1l-0.8-159.6c0,0,8.2-68.9,78.8-75.4L479.6,146.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamePoint);
export default __webpack_public_path__ + "static/media/game-point.3a1f7843d5de0a841bdb359965c7f43f.svg";
export { ForwardRef as ReactComponent };